import React from "react";

import { ModalProps } from "./types";

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = "",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50 font-satoshi">
      <div
        className={`relative bg-white dark:bg-black p-6 rounded-lg shadow-lg ${className}`}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 flex items-center justify-center 
             w-10 h-10 rounded-full text-gray-500 text-3xl
             hover:bg-gray-100 hover:text-gray-900 
             dark:text-gray-400 dark:hover:bg-[#FFFFFF1A] dark:hover:text-white 
             transition-all duration-200"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
